import { render, staticRenderFns } from "./RbuItemModuleDataPoint.vue?vue&type=template&id=1c77f8e6"
import script from "./RbuItemModuleDataPoint.vue?vue&type=script&lang=js"
export * from "./RbuItemModuleDataPoint.vue?vue&type=script&lang=js"
import style0 from "./RbuItemModuleDataPoint.vue?vue&type=style&index=0&id=1c77f8e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports